export default "__VITE_ASSET__c3680705__"